module.exports = __webpack_public_path__ + "img/img-2.ddc0fbc4.png";